import Storefront from '../../src/legacy/Storefront.tsx';
export default Storefront;
